import React, { useState, useEffect } from "react";

export default function DropDownMenu({ title, optionSelected, options, right }) {
  const [open, setOpen] = useState(false);
  const [option, setOption] = useState(title);

  const chooseOption = option => {
    optionSelected(option);
    setOption(option);
  };
  useEffect(() => {}, [title, optionSelected, options]);

  return (
    <div
      onClick={() => {
        setOpen(!open);
      }}
    >
      <div>
        <span className="rounded-md shadow-sm">
          <button
            type="button"
            className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
          >
            {option}
            <svg className="-mr-1 ml-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </span>
      </div>
      {open ? (
        <div className={"origin-top-right absolute mt-2 w-56 rounded-md shadow-lg z-50 " + (right ? "right-0" : "")}>
          <div className="rounded-md bg-white shadow-xs">
            {options.map((item, index) => (
              <div
                className="group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                onClick={() => {
                  chooseOption(item);
                }}
                key={index}
              >
                <svg
                  className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                  <path
                    fillRule="evenodd"
                    d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                    clipRule="evenodd"
                  />
                </svg>
                {item}
              </div>
            ))}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// src/modules/presence/components/DropDownMenu.js